// start:ng42.barrel
export * from './categoria-detail.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/categoria-detail/index.ts